import { apiService } from '@/services/core/api.service';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface WarehouseApiResponse {
  id: string;
  name: string;
  description: string | null;
  responsibleUserId: string | null;
  parentId: string | null;
  isActive: boolean;
  children?: WarehouseApiResponse[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateWarehousePayload {
  name: string;
  description?: string;
  responsibleUserId?: string;
  parentId?: string;
}

export type UpdateWarehousePayload = Partial<CreateWarehousePayload>;

// ─── Service ──────────────────────────────────────────────────────────────────

export const almacenApi = {
  findAll: (): Promise<WarehouseApiResponse[]> =>
    apiService.request<WarehouseApiResponse[]>('/almacen/almacenes'),

  findOne: (id: string): Promise<WarehouseApiResponse> =>
    apiService.request<WarehouseApiResponse>(`/almacen/almacenes/${id}`),

  create: (dto: CreateWarehousePayload): Promise<WarehouseApiResponse> =>
    apiService.request<WarehouseApiResponse>('/almacen/almacenes', {
      method: 'POST',
      body: JSON.stringify(dto),
    }),

  update: (id: string, dto: UpdateWarehousePayload): Promise<WarehouseApiResponse> =>
    apiService.request<WarehouseApiResponse>(`/almacen/almacenes/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(dto),
    }),

  remove: (id: string): Promise<void> =>
    apiService.request<void>(`/almacen/almacenes/${id}`, {
      method: 'DELETE',
    }),
};
